
function clog(label, callback) { 
    // var newCallback = callback || '...';
    var consoleLog = (callback !== undefined) ? console.log(label, callback) : console.log(label);
    if (site.env !== 'prd') {
      consoleLog;
    } else if ( site.env == 'prd' ) {
      if (site.enabledClog) {
      	!site.published ? consoleLog : false; // silence is golden
      } else {
      	return false;
      }
    }       
}

// Polyfill for 'assign'
if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

// Polyfill for 'includes'
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}